import React, { useEffect, useState } from "react";
import styled from "styled-components";
import GlobalStyle from "../../../GlobalStyle";
import eye from "../../../assets/img/icons/eye.svg";
import eye_cross from "../../../assets/img/icons/eye_cross.svg";

const Input = (props) => {
  const [active] = React.useState(props.type === "password");
  const {
    error,
    name,
    className,
    label,
    type,
    placeholder,
    onChange,
    onKeyPress,
    onFocus,
    errorDown,
    disabled,
    inAdvancedSearch,
    searchField,
    idInput,
    inNewListAsider,
    inputRef,
    errorMsg,
    errorClassName,
  } = props;

  return (
    <>
      <GlobalStyle />
      <Label {...props.labelProps}>
        {props.label}
        {props.optional && <span className="optional">(optional)</span>}
        {!errorDown && error ? (
          <span className={`error-msg ${errorClassName}`}>
            {typeof error === "boolean" ? (errorMsg ? errorMsg : "* This field is mandatory") : error}
          </span>
        ) : null}
      </Label>
      <InputWrapper>
        <Input1
          ref={inputRef}
          {...props}
          onChange={onChange}
          label={label}
          className={`${className} ${error ? "error" : ""} `}
          name={name}
          type={type}
          placeholder={placeholder}
          onKeyPress={onKeyPress ? onKeyPress : undefined}
          inAdvancedSearch={inAdvancedSearch}
          inNewListAsider={inNewListAsider}
          id={idInput}
        />
        <span
          onClick={props.is_password ? props.togglePassword : null}
          className={props.type === "password" ? "" : "active"}
        ></span>
        {errorDown ? (
          // <Label {...props.labelProps}>
          error ? (
            <span className={`error-msg-2 ${errorClassName}`}>
              {typeof error === "boolean" ? (errorMsg ? errorMsg : "* This field is mandatory") : error}
            </span>
          ) : null
        ) : null}
      </InputWrapper>
    </>
  );
};

export default Input;

const Label = styled.label`
  color: #5e7079;
  display: block;
  margin: ${(props) => (props.removeMargin ? "0 0 0 0" : "23px 0 8px 0")};
  font-size: 18px;
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "robotoregular")};
  font-weight: 600;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
  }
  .error-msg {
    color: #db3725;
    font-style: italic;
    font-size: 14px;
    text-align: right;
    float: right;
    margin-top: 1px;
    margin-right: 0;
    font-family: "robotomedium_italic";
    font-weight: normal;
  }
  .optional {
    color: rgb(94, 112, 121);
    font-size: 14px;
    padding-left: 10px;
    display: inline;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
`;

const InputWrapper = styled.div`
  position: relative;
  .error-msg-2 {
    color: #db3725;
    font-style: italic;
    font-size: 14px;
    text-align: right;
    float: right;
    margin-top: 1px;
    margin-right: 0;
    font-family: "robotomedium_italic";
    font-weight: normal;
  }
`;

const Input1 = styled.input`
  color: #424b50;
  border-radius: 10px;
  padding: 8px 18px;
  font-size: 16px;
  line-height: ${(props) => (props.searchField ? "20px" : "26px")};
  font-weight: 400;
  border: 1px solid #dadada;
  display: block;
  width: ${(props) => (props.inAdvancedSearch ? "330px" : props.searchField ? "200px" : "100%")};
  font-family: "robotoregular";
  opacity: ${(props) => (props.disabled ? "0.7" : "1")};
  margin-top: ${(props) => (props.searchField ? "-6px" : "")};
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
    line-height: 16px;
    padding: 7px 10px;
    border-radius: 6px;
    width: ${(props) => (props.inAdvancedSearch ? "220px" : props.searchField ? "130px" : "100%")};
    margin-top: ${(props) => (props.searchField ? "-4px" : "")};
  }
  &.error {
    box-shadow: none !important;
    border: 1px solid #db3725 !important;
  }
  &:active,
  &:focus {
    box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
    outline: none;
  }
  + span {
    display: none;
  }
  &.password + span {
    position: absolute;
    display: inline-block;
    right: 12px;
    cursor: pointer;
    width: 20px;
    top: 12px;
    height: 16px;
    background-size: contain;
    background-image: url(${eye_cross});
    background-repeat: no-repeat;
    transition: all 300ms;
    padding: 0;
    &.active {
      background-image: url(${eye});
      top: 15px;
      height: 12px;
    }
  }
  &.invalid {
    color: #db3725;
    border: 1px solid #db3725;
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: #ee1919 !important;
    }
  }
  &::placeholder {
    color: #c7c7c7;
    font-style: italic;
    font-size: ${(props) => (props.inAdvancedSearch ? "14px" : props.inNewListAsider ? "14px" : "16px")};
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: ${(props) => (props.inAdvancedSearch ? "10px" : "12px")};
    }
  }
  &::-webkit-input-placeholder {
    color: #c7c7c7;
    font-style: italic;
  }
  &:-moz-placeholder {
    color: #c7c7c7;
    font-style: italic;
  }
  &::-moz-placeholder {
    color: #c7c7c7;
    font-style: italic;
  }
  &:-ms-input-placeholder {
    color: #c7c7c7;
    font-style: italic;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: #424b50 !important;
  }
`;
